import { useMemo, useCallback } from "react"

export function useCategoryData(categories, relations, currentCategory) {
  const children = useMemo(() => {
    const childIds = relations
      .filter((r) => r.parentId === currentCategory.id)
      .map((r) => r.childId)
    return categories.filter((c) => childIds.includes(c.id))
  }, [currentCategory.id, relations, categories])

  const getParents = useCallback(
    (categoryId) => {
      const parentIds = relations
        .filter((r) => r.childId === categoryId)
        .map((r) => r.parentId)
      return categories.filter((c) => parentIds.includes(c.id))
    },
    [relations, categories]
  )

  const getChildrenCount = useCallback(
    (categoryId) => relations.filter((r) => r.parentId === categoryId).length,
    [relations]
  )

  return { children, getParents, getChildrenCount }
}
